import { Box, BoxProps, LoaderNew, ModBox, Text, TextProps } from '@jfs/ui-new'
import { useEffect, useState } from 'react'

export const ResendOtp = ({ onResendOTPPress, showLoader = false }: any) => {
  const [resendCount, setResendCount] = useState(0)
  const [countDowntimer, setCountDownTimer] = useState(30)

  useEffect(() => {
    let timer: any
    if (countDowntimer > 0) {
      timer = setTimeout(() => setCountDownTimer(countDowntimer - 1), 1000)
    }
    return () => clearTimeout(timer)
  }, [countDowntimer])

  const onResendOtp = () => {
    setCountDownTimer(30)
    setResendCount(resendCount + 1)
    onResendOTPPress()
  }

  if (showLoader) {
    return (
      <Box alignItems={'center'}>
        <LoaderNew type={'small'} color={'PRIMARY'} />
      </Box>
    )
  }

  return (
    <Box alignItems={'center'} marginTop={-16}>
      {countDowntimer > 0 ? (
        <ShowCountingText {...{ countDowntimer, resendCount }} />
      ) : (
        <ShowResend {...{ resendCount, onResendOtp }} />
      )}
    </Box>
  )
}

const ShowCountingText = ({ countDowntimer, resendCount }: any) => {
  return (
    <Text {...styles.countStyle}>
      {countDowntimer > 0 && resendCount < 3 ? `Resend OTP  ( ${countDowntimer} )` : ''}
    </Text>
  )
}

const ShowResend = ({ resendCount, onResendOtp }: any) => (
  <ModBox onPress={onResendOtp} show={resendCount < 3} underlayColor={'TRANSPARENT'}>
    <Text {...styles.resendText}>{`Resend OTP ( ${3 - resendCount} )`}</Text>
  </ModBox>
)

const styles = {
  resendText: {
    fontSize: 14,
    fontFamily: 'JioType-Medium',
    color: 'PRIMARY',
  } as TextProps,
  countStyle: {
    fontSize: 14,
    fontFamily: 'JioType-Medium',
    color: 'BLACK_75',
  } as TextProps,
  resendOtpButton: {
    underlayColor: 'WHITE',
    hoverColor: 'WHITE',
    borderBottomWidth: 1,
    pb: 4,
    borderBottomColor: 'PRIMARY',
  } as BoxProps,
}
